module.exports = __webpack_public_path__ + "static/media/sidebar_profile_disable.ba221540.svg";